var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_487_5159",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_487_5159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75098 6.93538C7.36086 8.55216 5.94276 9.87354 4.15251 9.87354C2.41501 9.87354 0.97173 8.57832 0.575292 6.93538C0.089136 4.9221 1.3482 3.11463 2.70085 1.75522C3.15439 1.29941 3.6357 0.857784 4.15251 0.473565C4.1557 0.471002 4.15926 0.469378 4.16311 0.468097C4.16698 0.469378 4.17057 0.471002 4.17376 0.473565C4.69054 0.857784 5.17189 1.29941 5.62542 1.75522C6.97807 3.11463 8.23714 4.9221 7.75098 6.93538Z",
    stroke: "#01152E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15234 4.12672V15.5312",
    stroke: "#01152E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15163 7.65259L2.51953 6.02049",
    stroke: "#01152E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15234 6.09009L5.78444 4.45799",
    stroke: "#01152E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90625 13.4438H15.5309",
    stroke: "#01152E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90625 11.5691H15.5309V9.69409H7.90625V11.5691Z",
    stroke: "#01152E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84375 11.569V15.5312",
    stroke: "#01152E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5938 11.569V15.5312",
    stroke: "#01152E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.46875 15.5312H15.5312",
    stroke: "#01152E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarden);
export default __webpack_public_path__ + "static/media/garden.f328e28b10abb03ae5241001a33abc6c.svg";
export { ForwardRef as ReactComponent };